import { render, staticRenderFns } from "./SkillsTable.vue?vue&type=template&id=480d2650&scoped=true&"
import script from "./SkillsTable.vue?vue&type=script&lang=js&"
export * from "./SkillsTable.vue?vue&type=script&lang=js&"
import style0 from "./SkillsTable.vue?vue&type=style&index=0&id=480d2650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d2650",
  null
  
)

export default component.exports